import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import PrivilegedDropCreator, { DropMode } from "@/components/waves/PrivilegedDropCreator";
interface WaveDropCreateProps {
  readonly wave: ApiWave;
  readonly onCancel: () => void;
  readonly onSuccess: () => void;
}
export const WaveDropCreate: React.FC<WaveDropCreateProps> = t0 => {
  const $ = _c(10);
  const {
    wave,
    onCancel,
    onSuccess
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-base tw-font-semibold tw-text-iron-200">Create a New Drop</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="tw-size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" /></svg>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onCancel) {
    t3 = <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">{t1}<button onClick={onCancel} className="tw-bg-transparent tw-border-0 tw-text-iron-400 desktop-hover:hover:tw-text-iron-200 tw-transition-all tw-duration-300 tw-ease-out tw-rounded-lg tw-p-1">{t2}</button></div>;
    $[2] = onCancel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onSuccess || $[5] !== wave) {
    t4 = <PrivilegedDropCreator wave={wave} onCancelReplyQuote={_temp} onDropAddedToQueue={_temp2} onAllDropsAdded={onSuccess} dropId={null} activeDrop={null} fixedDropMode={DropMode.PARTICIPATION} />;
    $[4] = onSuccess;
    $[5] = wave;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="tw-mb-4 tw-bg-iron-950 tw-rounded-xl tw-p-4 tw-ring-1 tw-ring-inset tw-ring-iron-800">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp() {}
function _temp2() {}